/** Scores 0–100, RTDB string sort aligned with numeric order when padded */
const PADDED_LENGTH = 3;

/**
 * Pads an integer health score for lexicographic order in composite keys (0–100).
 * Do not use for the numeric `healthScore` field in RTDB — only for composite strings.
 */
export const formatHealthScorePaddedForOrderBy = (healthScore) => {
  if (typeof healthScore !== "number" || !Number.isFinite(healthScore)) {
    return "0".repeat(PADDED_LENGTH);
  }
  const clamped = Math.max(0, Math.min(100, Math.round(healthScore)));
  return String(clamped).padStart(PADDED_LENGTH, "0");
};

/**
 * Value for `advertisers/{id}/healthScoreIsPlanActive` (orderByChild: plan first, then health).
 * Format: "{true|false|null}-{000-100}"
 */
export const formatHealthScoreIsPlanActive = ({
  healthScore,
  isPlanActive,
}) => {
  return `${isPlanActive}-${formatHealthScorePaddedForOrderBy(healthScore)}`;
};
